module.exports = __webpack_public_path__ + "media/images/brand/img-subslogan-563eda3cbe1b58214968247c2cc6ecdf.svg";